export const locale = {
    lang: 'pl',
    data: {
        'DELETE': 'Usuń',
        'EDIT': 'Edycja',
        'SAVE': 'Zapisz',
        'Cancel': 'Anuluj',
        'CANCEL': 'Anuluj',
        'Confirm': 'Potwierdź',
        'Are you sure you want to left current window?': 'Czy na pewno chcesz opuścić bieżące okno?',
        'Confirm deletion': 'Potwierdź usunięcie',
        'Are you sure you want to delete selected gallery?': 'Czy na pewno chcesz usunąć wybraną galerię?',
        'Resource': 'Zasób',
        'Are you sure you want to delete selected item?': 'Czy na pewno chcesz usunąć wybrane zdjęcie?',
        'Image for recommended page': 'Zdjęcie do strony polecanych',
        'Image for newest page': 'Zdjęcie do strony najnowszych',
        'Image for the category page': 'Zdjęcie do strony kategorii',
        'Image for vouchers list page': 'Zdjęcie dla strony listy karnetów',
        'Image for details page': 'Zdjęcie dla strony szczegółów',
        'Image for basket page': 'Zdjęcie dla strony koszyka',
    }
};
